module.exports = __webpack_public_path__ + "static/media/Материали и предложения за решения 2024.4e0985b5.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2024/Материали и предложения за решения 2024.pdf
// module id = 90
// module chunks = 0